import { render, staticRenderFns } from "./IconUseMaterial.vue?vue&type=template&id=557c06c0&scoped=true&"
import script from "./IconUseMaterial.vue?vue&type=script&lang=js&"
export * from "./IconUseMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c06c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557c06c0')) {
      api.createRecord('557c06c0', component.options)
    } else {
      api.reload('557c06c0', component.options)
    }
    module.hot.accept("./IconUseMaterial.vue?vue&type=template&id=557c06c0&scoped=true&", function () {
      api.rerender('557c06c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconUseMaterial.vue"
export default component.exports